import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-rcr-takedown-container',
  templateUrl: './available-rcr-takedowns.component.html',
  styleUrls: ['./available-rcr-takedowns.component.scss'],
})
export class AvailableRcrTakedownsComponent implements OnInit {
  public steps: Array<object>;
  public currentStep = '/rcr-exchange/rcr-takedown';

  ngOnInit() {
    this.steps = [
      {
        url: '/rcr-exchange/rcr-takedown',
        title: 'Available Takedowns',
      },
      {
        url: '/enter-takedowns',
        title: 'Enter Takedowns',
      },
      {
        url: '/review-and-commit',
        title: 'Review & Submit',
      },
      {
        url: '/confirm',
        title: 'Confirmation',
      },
    ];
  }
}
